import { useWatchEventsAndSyncGameCache } from '@thriveglobal/thrive-web-journeys'

function GameCacheSyncWrapper() {
    useWatchEventsAndSyncGameCache()
    return <></>
}

export default GameCacheSyncWrapper
